import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { map, Observable } from 'rxjs';
import { GET_CREDIT_CARDS, GET_CREDIT_CARD_BY_ID } from '../graphql/queries/credit-card.query';

@Injectable({
  providedIn: 'root'
})
export class CreditCardService {

  constructor(private apollo: Apollo) { }

  fetchCreditCards(search: string = ''): Observable<any> {
    return this.apollo
      .use('accounts')
      .watchQuery<any>({
        query: GET_CREDIT_CARDS,
        variables: { search },
        fetchPolicy: 'network-only'
      })
      .valueChanges.pipe(
        map((result) => result.data?.creditCards || [])
      );
  }

  getCreditCardById(id: number): Observable<any> {
    return this.apollo
      .use('accounts')
      .watchQuery<any>({
        query: GET_CREDIT_CARD_BY_ID,
        variables: { id },
        fetchPolicy: 'network-only'
      })
      .valueChanges.pipe(
        map((result) => result.data?.creditCard || [])
      );
  }
} 